export const IconToggleClose = (props) => {
    return (
        <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.999999 3L1 21C1 22.1046 2.34315 23 4 23L22 23C23.6569 23 25 22.1046 25 21L25 3C25 1.89543 23.6569 1 22 1L4 1C2.34314 1 0.999999 1.89543 0.999999 3Z" stroke="#1A1A1B" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18 23L18 1" stroke="#1A1A1B" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.2913 12.5L5.70801 12.5" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.49967 16.2923L5.70801 12.5007L9.49967 8.70898" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}